import type { IPackagesPrice } from "../types";
import { usePackagePurchase } from "../usePackagePurchase";

export const useStepPackages = (packages?: IPackagesPrice | null) => {
    const { currentCurrency, onSubmitStep } = usePackagePurchase(packages);

    return {
        currentCurrency,
        onSubmitStep,
    };
};
